import { createReducer } from '@reduxjs/toolkit';

import deleteCoOrder from '../../../thunks/coilovers/orders/deleteCoOrder';
import { clearDeleteCoOrders } from '../../../actions/coilovers/orders/patchCoOrders';

const initialState = {
  loading: false,
  error: null,
  id: false,
};

const deleteCoOrderReducer = createReducer(initialState, {
  [deleteCoOrder.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [deleteCoOrder.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    id: payload,
  }),
  [deleteCoOrder.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearDeleteCoOrders]: () => initialState
});

export default deleteCoOrderReducer;
